import { useState, useEffect } from 'react';

export function useBreakpoint(query) {
    const media = window.matchMedia(query);
    const getValue = () => media.matches;
    const [value, setValue] = useState(getValue);

    useEffect(
        () => {
            const handler = () => setValue(getValue);
            media.addListener(handler);
            return () => media.removeListener(handler);
        },
        [] // eslint-disable-line react-hooks/exhaustive-deps
    );

    return value;
}
